export const ROUTE_DPTO_ID = ":dptoId";

export function routeDpto(schoolId: string, dptoId: string): string {
    return `/school/${schoolId}/dpto/${dptoId}`;
}

export function routeDptoEdit(schoolId: string, dptoId: string): string {
    return `/school/${schoolId}/dpto/${dptoId}/edit`;
}

export function routeDptoImage(schoolId: string, dptoId: string): string {
    return `/school/${schoolId}/dpto/${dptoId}/image`;
}

export function routeDptoNew(schoolId: string): string {
    return `/school/${schoolId}/dpto/new`;
}

// export function routeDptoStudentAdd(schoolId: string, dptoId: string): string {
//     return `/school/${schoolId}/dpto/${dptoId}/student/add`;
// }

// export function routeDptoUserAdd(schoolId: string, dptoId: string): string {
//     return `/school/${schoolId}/dpto/${dptoId}/user/new`;
// }

// export function routeDptoImagesAdd(schoolId: string, dptoId: string): string {
//     return `/school/${schoolId}/dpto/${dptoId}/images/add`;
// }